import './DeletePreferenceButton.css';
import React from "react";
import {SimplePreference} from '../simple/SimplePreference';

interface DeletePreferenceButtonProps {
    preference: SimplePreference;
    deletePreferences: (preference: SimplePreference) => void;
    numberOfApplicableSongs?: number | undefined;
}

export const DeletePreferenceButton = (props: DeletePreferenceButtonProps) => {
    function handleOnClick() {
        props.deletePreferences(props.preference);
    }

    return (
        <div>
            <div onClick={() => handleOnClick()} className={"deletePreferenceButton unselectable"}>
                <div className={"deletePreferenceContent"}>
                    <div className="deletePreferenceContentText">
                        <span>{props.preference.name}</span> <span className={"numberOfApplicableSongs"}>{props.numberOfApplicableSongs}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}